jQuery(function ($) {
    const $posts = $('#blog-posts');
    const $pagination = $('#blog-pagination');
    const $filters = $('.blog-filter');
    const $search = $('#blog-search');
    const $searchForm = $search.closest('.blog-search');

    if (!$posts.length || typeof blogAjax === 'undefined') {
        return;
    }

    let page = 1;
    let category = 'all';
    let searchTerm = '';
    let searchTimeout;
    let currentRequest;
    let lastLoadedSearchTerm = null;

    function setLoading(isLoading) {
        $searchForm.toggleClass('is-loading', isLoading);
        $searchForm.find('button[type="submit"]').attr('aria-busy', isLoading ? 'true' : 'false');
        $posts.attr('aria-busy', isLoading ? 'true' : 'false');
    }

    function loadPosts() {
        if (currentRequest) {
            currentRequest.abort();
        }

        setLoading(true);
        const request = $.ajax({
            url: blogAjax.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'blog_filter',
                nonce: blogAjax.nonce,
                page: page,
                cat: category,
                search: searchTerm
            }
        });
        currentRequest = request;

        request.done(function (response) {
            if (!response || !response.success || !response.data) {
                $posts.html('<p class="blog-filter-error">Unable to load articles. Please try again.</p>');
                $pagination.empty().hide();
                return;
            }

            $posts.html(response.data.posts);
            lastLoadedSearchTerm = searchTerm;

            if (response.data.pagination) {
                $pagination.html(response.data.pagination).show();
            } else {
                $pagination.empty().hide();
            }
        }).fail(function (xhr, status) {
            if ('abort' !== status) {
                $posts.html('<p class="blog-filter-error">Unable to load articles. Please try again.</p>');
                $pagination.empty().hide();
            }
        }).always(function () {
            if (currentRequest === request) {
                currentRequest = null;
                setLoading(false);
            }
        });
    }

    loadPosts();

    $('.blog-filters').on('click', '.blog-filter', function () {
        const $filter = $(this);

        $filters.removeClass('is-active');
        $filter.addClass('is-active');
        category = $filter.data('match') || 'all';
        page = 1;
        window.clearTimeout(searchTimeout);
        loadPosts();
    });

    $('.blog-search').on('submit', function (event) {
        event.preventDefault();
        searchTerm = $search.val().trim();
        page = 1;
        window.clearTimeout(searchTimeout);
        if (searchTerm !== lastLoadedSearchTerm) {
            loadPosts();
        }
    });

    $search.on('input', function () {
        searchTerm = $search.val().trim();
        window.clearTimeout(searchTimeout);
        if (searchTerm === lastLoadedSearchTerm && !currentRequest) {
            setLoading(false);
            return;
        }

        setLoading(true);
        searchTimeout = window.setTimeout(function () {
            page = 1;
            loadPosts();
        }, 300);
    });

    $pagination.on('click', 'a[data-page]', function (event) {
        event.preventDefault();

        const requestedPage = Number.parseInt($(this).data('page'), 10);
        if (requestedPage > 0 && requestedPage !== page) {
            page = requestedPage;
            window.clearTimeout(searchTimeout);
            loadPosts();
        }
    });
});
